export const DEFAULT_FLAME_THEME = {
    primary: "#F25C1F",
    highlight: "#FF8A3D",
    deep: "#C43110",
    background: "#060B1E",
    usePrimary: true,
    useHighlight: true,
    useDeep: true,
    useBackground: true,
    applyWhenLive: true,
};
//# sourceMappingURL=types.js.map